<template>


  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" :data="users">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                 @click="open_drawer(-1)">

                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary" >Novo Email</span>

            </div>

            <!--pesquisa -->
            <div class="con-input-search vs-table--search" style="margin-left: 580px">
              <input class="input-search vs-table--search-input" name="prefixo" v-model="searchEmail" />
              <i class="material-icons">
                search
              </i>
            </div>

          <Drawer title="Emails" v-model="active" width="600" >
              <Form :label-width="80" @keydown.native.enter.prevent>

                <div class="vx-col w-full">
                  <vs-input label="Email"
                            size="large"
                            :color="!isValidEmail ? 'danger' : 'success' "
                            v-validate="'email'"
                            placeholder="Digite seu email"
                            name="email"
                            v-model="newEmail.email"
                            class="mt-5 w-full" />
                </div>

                <FormItem>
                    <!--Essa lógica é para aparecer o botão quando digitar algum caracter-->
                    <div class="floating-btn"
                         v-if="(isValidEmail && isChange) || /*caso houve mudanca e o email for valido o botao aparece*/
                                (isValidEmail && !isChange && newEmail.index == -1) /*ou se o email for valido e nao houve mudanca
                                                                                                    entao esse email eh um novo email, e tambem
                                                                                                    deve aparecer o botao*/">
                      <Button
                              type="primary"
                              icon="md-checkmark"
                              shape="circle"
                              size="large"
                              style="margin-top: 4px; margin-left: 450px"
                              @click="cadastra(newEmail)"
                      ></Button>

                    </div>
                </FormItem>
              </Form>

          </Drawer>

        </div>
      </div>

      <template slot="thead">
        <vs-th>Email</vs-th>
      </template>

        <template slot-scope="{data}" >
          <tbody >

            <vs-tr :data="tr"
                   :key="indextr"
                   v-for="(tr, indextr) in data"
                   class="row-list"
                   >
            <div class="container-white-list" >

              <vs-td >
                <div class="email-plus-icon">
                  <p class="product-name font-medium" @click="open_drawer(indextr)" style=" padding:10px;" >{{ tr.email }} </p>
                  <i class="material-icons" id="icon-create">
                    create
                  </i>
                </div>
              </vs-td>

              <div @click="apaga_email(tr, indextr)">
                <Button class="button-trash"
                        icon="ios-trash-outline"
                        shape="circle"
                        size="large"
                        ghost
                        type="error"
                        style="margin-right: 5px;"
                        :id = "indextr"
                ></Button>
              </div>
            </div>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<style>
  .button-trash{
    visibility: hidden;
  }

  .row-list:hover .button-trash{
    visibility: visible;
  }

  .container-white-list{
      display: flex;
      align-items: center;
      justify-content: space-between;
  }

  #icon-create {
    visibility: hidden;
  }

  .email-plus-icon:hover #icon-create{
    visibility: visible;
  }

  .email-plus-icon:hover {
    color: #17C9E8;
  }

  .email-plus-icon{
    display: flex;
    align-items: center;
  }
</style>

<script>


export default {

  data() {
      return {
        newEmail: {
            email: '',
            id: -1,
            index: -1,
        },
        users: [], /*mantém todos os usuários mostrados na tela*/
        active: false, /*sidebar (tela do novo email)*/
        page: 1, /*contador de indice dos emails no scroll infinito*/
        searchEmail: '',/*string para buscar por um email*/
        last_page: 0, /*ultima pagina retornada do paginate -> é populada na primeira chamada do getEmails*/

        }
    },
    watch: {
      searchEmail(){
          this.busca()
      }
    },
    computed: {

      isValidEmail(){
          /*o email pode ser algo do tipo = jorge@adha.com ou jorge@lasdm.com.asd*/
          let deflt = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

          if (deflt.test(this.newEmail.email)){
              return true
          } else {
              return false
          }
      },

      /*verifica se o email que o usuario deseja alterar realmente foi
      alterado para poder mostrar o botao de confirmacao*/
      isChange(){
        let index = this.newEmail.index;
        if (index != -1 && this.users.length > 0) {
          if (this.newEmail.email != this.users[index].email) {
            return true
          }
        }
        return false
      },

    },
    methods: {
        /*funcao para mostrar a page de loading enquanto busca os emails*/
        openLoading (active) {
            if (active) {
                this.$vs.loading({
                    type: "point",
                })
            } else {
                this.$vs.loading.close()
            }
        },
        /*função para ativação do drawer
          parametro: o id de uma pessoa
        * esse id corresponde também a posição da mesma dentro do array*/
        open_drawer(index){
          this.active = true;

          if (index != - 1){/*Se o index é diferente de -1, significa o objeto email é
                            um cadastrado, então eu populo o campo 'email'
                            do objeto newEmail, com o objeto selecionado*/
            this.newEmail.email = this.users[index].email
            this.newEmail.id = this.users[index].id
            this.newEmail.index = index
          } else {
            this.newEmail.email = ''
            this.newEmail.id = -1
            this.newEmail.index = -1
          }
        },

        /*funcao para cadastrar um novo email, e alterar
        * parametro: o email com os campos populados*/
        async cadastra(objEmail){
          try {
              if (objEmail.id == -1) {/*se o id == -1, será um novo email, se não é uma alteração*/

                const URI = '/emails';
                await this.$axios.post(URI, objEmail)
                        .then((data) => {
                          if (data.data.status == 2) {
                            this.$Message.error('Ops! O e-mail já existe');
                          }
                          if (data.data.status == 1) {
                            this.$Message.success('E-mail cadastrado com sucesso!');
                          }
                        })
              } else {

                const URI = `emails/${objEmail.id}`
                await this.$axios.put(URI, objEmail)
                        .then((data) => {
                          if (data.data.status == 2)
                            this.$Message.error('Ops! O e-mail já existe');
                          if (data.data.status == 1) {
                            this.$Message.success('E-mail alterado com sucesso!');
                          }
                        })
              }

            this.newEmail.email = ''
            this.newEmail.id = -1
            this.newEmail.index = -1
            this.active = false;/*inativa o drawer*/

            await this.getEmails();

          } catch (err) {
            console.warn(err);
          }
        },

        /*função para apagar um email
        * parâmetro: o id do email (que corresponde também a sua posição)*/
        async apaga_email(tr, index){
          try {
            const URI = `/emails`
            await this.$axios.delete(URI, {data: tr})
                    .catch((err) => console.log(err))
            this.users.splice(index, 1);
            this.$Message.success('Email removido com successo!');
          } catch (err) {
            console.warn(err);
          }
        },

        loadMore(res){
            let usr = res.data.data.map(usr => ({
              email: usr.email,
              id: usr.id_whitelist
            }))
            this.users = this.users.concat(usr);
        },

        /*busca mais emails para o scroll infinito*/
        async infiniteScroll(){
          try {
            if (this.page <= this.last_page) { //verifica se ainda há mais paginas para mostrar
              let URI = `emails?page=${this.page}`
              if (this.searchEmail != '')/*verifica se a busca será em todos os emails ou em uma busca*/
                URI = `emails/${this.searchEmail}?page=${this.page}`
              this.openLoading(true)
              this.page++
              await this.$axios.get(URI)
                      .then((dados) => {
                          this.loadMore(dados);
                      })
              this.openLoading(false)
            }
          } catch (err){
            console.warn(err);
          }
        },

        /*função para calculo verificar se o usuário rolou a barra de rolagem para o final, para que possa ser
        * carregado mais emails dentro da tela*/
        scroll () {
          window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= document.documentElement.scrollHeight;

            if (bottomOfWindow) {
              this.infiniteScroll()
            }
          };
        },

        /*recupera os emails
        * se for o tipo 1, deverah zerar o índice inicial, buscando a quantidade de emails definida
        * */
        async getEmails(){
          try {
            this.openLoading(true)
            const URI = `emails?page=1`
            await this.$axios.get(URI)
                    .then((dados)=> {
                        this.users = dados.data.data.map(item => ({
                          email: item.email,
                          id: item.id_whitelist,
                        }))
                        this.last_page = dados.data.last_page
                        this.page = 2
                    })
            this.openLoading(false)
          } catch (err) {
            console.warn(err)
          }

        },

        /*realiza uma busca dinamica no banco de dados
        * com base no prefixo digitado pelo usuario*/
        async busca (){
          try {
            if (this.searchEmail != '') {
              const URI = `emails/${this.searchEmail}?page=1`
              await this.$axios.get(URI)
                      .then((dados) => {
                        this.page = 2;
                        this.last_page = dados.data.last_page;
                        if (parseInt(dados.data.data.length) > 0) {
                          this.users = dados.data.data.map(item => ({
                            email: item.email,
                            id: item.id_whitelist,
                          }))
                        } else {
                          this.users = [];
                        }

                      })

            } else {
              this.getEmails()
            }
          } catch (err) {
            console.warn(err);
          }
        }

    },
    mounted() {
        this.getEmails()
        this.scroll()
    }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>


